import React from 'react';
import { BooleanColumn, NumericalColumn, CustomColumn, CategoricalColumn, StringColumn } from 'baseui/data-table';
import { useStyletron } from 'baseui';

import { CustomDateColumn } from 'commons-ui';

export const COL_NAMES = {
	code: 'code',
	description: 'description',
	validFrom: 'validFrom',
	validTill: 'validTill',
	allowedPaymentModes: 'allowedPaymentModes',
	isFirstDeposit: 'isFirstDeposit',
	maxRedemptions: 'maxRedemptions',
	isDisabled: 'isDisabled',
	maxRedemptionsPerPerson: 'maxRedemptionsPerPerson',
	isSecondDeposit: 'isSecondDeposit',
	redemptionInterval: 'redemptionInterval',
	type: 'type',
	isPartnerCoupon: 'isPartnerCoupon',
	createdOn: 'createdOn',
	uptoCashback: 'uptoCashback',
	cashbackExpiryInHours: 'cashbackExpiryInHours'
};

export const columnConfigs = [
	CategoricalColumn({
		title: 'Code',
		maxWidth: 450,
		minWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.code] || ''
	}),
	CustomDateColumn({
		title: 'Valid From',
		maxWidth: 450,
		columnName: COL_NAMES.validFrom
	}),
	CustomDateColumn({
		title: 'Valid Till',
		maxWidth: 250,
		columnName: COL_NAMES.validTill
	}),
	CustomColumn({
		title: 'Is Deployed',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled],
		renderCell: (params: any) => {
			const { value } = params;
			const [css] = useStyletron();
			return (
				<div
					className={css({
						backgroundColor: !value ? 'green' : 'red',
						height: '100%',
						width: '100%'
					})}
				/>
			);
		}
	}),
	BooleanColumn({
		title: 'Is First Deposit',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isFirstDeposit]
	}),
	BooleanColumn({
		title: 'Is Second Deposit',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.isSecondDeposit]
	}),
	CustomColumn({
		title: 'allowedPaymentModes',
		mapDataToValue: (data: any) => (data[COL_NAMES.allowedPaymentModes] || []).join(','),
		renderCell: (params: any) => params.value || ''
	}),
	CategoricalColumn({
		title: 'Type',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.type] || ''
	}),
	NumericalColumn({
		title: 'Max No. of Redemptions',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptions] || ''
	}),
	NumericalColumn({
		title: 'Max Redemptions Per Person',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.maxRedemptionsPerPerson] || ''
	}),
	NumericalColumn({
		title: 'Redemption Interval',
		maxWidth: 200,
		mapDataToValue: (data: any) => data[COL_NAMES.redemptionInterval] || ''
	}),
	CustomDateColumn({
		title: 'Created On',
		maxWidth: 200,
		columnName: COL_NAMES.createdOn
	}),
	NumericalColumn({
		title: 'Upto Cashback',
		mapDataToValue: (data: any) => data[COL_NAMES.uptoCashback] || '',
		maxWidth: 200
	}),
	StringColumn({
		title: 'Description',
		mapDataToValue: (data: any) => data[COL_NAMES.description] || ''
	}),
	NumericalColumn({
		title: 'Cashback Expiry',
		mapDataToValue: (data: any) => data[COL_NAMES.cashbackExpiryInHours] || ''
	}),
	BooleanColumn({
		title: 'Is Disabled',
		mapDataToValue: (data: any) => data[COL_NAMES.isDisabled]
	})
];

export const activeFilter = [
	{
		columnKey: 'Is Disabled',
		filterLabel: 'Active Coupons',
		filterValue: false
	}
];
